exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");

// module
exports.push([module.id, ".dropdown_5d7 {\n  display: inline-block;\n}\n\n.anchor_93a.anchor_93a {\n  margin: 0 -3px;\n  padding: 0 3px;\n\n  font: inherit;\n}\n\n.chevron_7e5 {\n  margin-left: 2px;\n\n  vertical-align: 1px;\n\n  line-height: normal;\n}\n", ""]);

// exports
exports.locals = {
	"dropdown": "dropdown_5d7",
	"anchor": "anchor_93a",
	"chevron": "chevron_7e5"
};